import React, { useEffect, createElement } from 'react';
import { Helmet } from 'react-helmet';
export const MetaPixel = () => {
  useEffect(() => {
    // Initialize Facebook Pixel
    if (typeof window !== 'undefined') {
      // Define fbq if it doesn't exist
      if (!window.fbq) {
        window.fbq = function () {
          if (window.fbq.callMethod) {
            window.fbq.callMethod.apply(window.fbq, arguments);
          } else {
            window.fbq.queue.push(arguments);
          }
        };
      }
      // Set up _fbq if it doesn't exist
      if (!window._fbq) {
        window._fbq = window.fbq;
      }
      window.fbq.push = window.fbq;
      window.fbq.loaded = true;
      window.fbq.version = '2.0';
      window.fbq.queue = [];
      // Initialize with your Pixel ID
      window.fbq('init', '412164571520715');
      // Track PageView event
      window.fbq('track', 'PageView');
    }
  }, []);
  return <Helmet data-id="element-80">
      <script dangerouslySetInnerHTML={{
      __html: `
            !function(f,b,e,v,n,t,s)
            {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
            n.callMethod.apply(n,arguments):n.queue.push(arguments)};
            if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
            n.queue=[];t=b.createElement(e);t.async=!0;
            t.src=v;s=b.getElementsByTagName(e)[0];
            s.parentNode.insertBefore(t,s)}(window, document,'script',
            'https://connect.facebook.net/en_US/fbevents.js');
            fbq('init', '412164571520715');
            fbq('track', 'PageView');
          `
    }} data-id="element-81" />
      <noscript data-id="element-82">
        {`
          <img 
            height="1" 
            width="1" 
            style="display:none" 
            src="https://www.facebook.com/tr?id=412164571520715&ev=PageView&noscript=1"
          />
        `}
      </noscript>
    </Helmet>;
};